"use strict";

var _slicedToArray = require("/home/runner/work/react-nexys-boilerplate/react-nexys-boilerplate/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.replaceLinks = exports.substituteVars = void 0;

var react_1 = __importStar(require("react"));

var react_router_dom_1 = require("react-router-dom");

var ui_1 = require("../../ui");

var Data = __importStar(require("./data"));

exports.substituteVars = function (content, replaceVars) {
  var prefixVar = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '\\${';
  var suffixVar = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '}';

  if (!replaceVars) {
    return content;
  }

  Object.entries(replaceVars).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        k = _ref2[0],
        v = _ref2[1];

    var wrappedKey = prefixVar + k + suffixVar;
    var rgp = new RegExp(wrappedKey, 'g');
    content = content.replace(rgp, v);
  });
  return content;
};

exports.replaceLinks = function (content) {
  return content.replace(/<a.*href="(.+)"[^>]*>(.+)<\/a>/, '<a onClick="javascript: redirectFunction(\'$1\')" href="javascript: void(0)">$2</a>');
};

exports.default = function (props) {
  var _react_1$useState = react_1.useState(null),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      content = _react_1$useState2[0],
      setContent = _react_1$useState2[1];

  var _react_1$useState3 = react_1.useState(null),
      _react_1$useState4 = _slicedToArray(_react_1$useState3, 2),
      redirect = _react_1$useState4[0],
      setRedirect = _react_1$useState4[1];

  var clickHandler = function clickHandler(event) {
    if (event) {
      var link = event.target.getAttribute('href');

      if (link && !link.match(/^http/)) {
        event.preventDefault();
        setRedirect(link);
      }
    }
  };

  if (redirect) {
    return react_1.default.createElement(react_router_dom_1.Redirect, {
      to: redirect
    });
  }

  var _props$fetchData = props.fetchData,
      fetchData = _props$fetchData === void 0 ? Data.getData : _props$fetchData,
      uuid = props.uuid,
      _props$lang = props.lang,
      lang = _props$lang === void 0 ? 'en' : _props$lang,
      _props$isHtml = props.isHtml,
      isHtml = _props$isHtml === void 0 ? true : _props$isHtml,
      replaceVars = props.replaceVars;

  if (content === null) {
    fetchData(uuid, lang, isHtml).then(function (cms) {
      var content = cms.content;
      setContent(content);
    });
    return react_1.default.createElement(ui_1.Loader, null);
  }

  var contentFinal = exports.substituteVars(content, replaceVars);

  if (isHtml) {
    return react_1.default.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: contentFinal
      },
      onClick: clickHandler
    });
  }

  return react_1.default.createElement(react_1.default.Fragment, null, "content");
};